import { useCallback, useEffect, useRef } from 'react';

const useDebouncedCallback = (callback, delay = 250) => {
  const callbackRef = useRef(callback);
  const timerRef = useRef(null);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const cancel = useCallback(() => {
    if (timerRef.current === null) return;
    window.clearTimeout(timerRef.current);
    timerRef.current = null;
  }, []);

  const schedule = useCallback((...args) => {
    cancel();
    timerRef.current = window.setTimeout(() => {
      timerRef.current = null;
      callbackRef.current?.(...args);
    }, delay);
  }, [cancel, delay]);

  useEffect(() => cancel, [cancel]);

  return { schedule, cancel };
};

export default useDebouncedCallback;
